// Add .is-empty for empty product blocks so we can remove extra space.
document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelectorAll('.product-block').forEach(el=>{
    if (!el.textContent.trim()) el.classList.add('is-empty')
  })
});